module.exports = __webpack_public_path__ + "img/reelables-r-logo-teal.bd57b0fc.svg";